import React from 'react';
import PT from 'prop-types';
import map from 'lodash.map';
import classes from './team.css';
import TeamsType from '../../../lib/proptypes/teams';
import { SORTED_DIVISIONS } from '../../../store/actions/teams.types';
import Link from '../../../lib/components/link';
import { viewTeam, viewTeamSubview } from '../../views/Team/module/team';

// This creates the individual teams displaying their logo and team name
// Passing in hasSubLinks shows the news, stats, and roster links
const IndividualTeam = (id, image, city, teamName, teamNameSlug, hasSubLinks) => {
  if (city != 'Free' && teamName != 'Agent') {
  return (
  <div className={classes.teamWrapper} key={id}>
    <Link
      action={hasSubLinks ? viewTeam({ id, teamName: teamNameSlug }) : viewTeamSubview({ id, subview: 'roster', teamName: teamNameSlug })}
    >
      <img className={classes.teamLogo} src={image} alt="" />
    </Link>
    <div className={classes.linksWrapper}>
      <Link className={classes.teamText} action={hasSubLinks ? viewTeam({ id, teamName: teamNameSlug }) : viewTeamSubview({ id, subview: 'roster', teamName: teamNameSlug })}>
        {city} {teamName}
      </Link>
      {hasSubLinks &&
        <div className={classes.subLinksWrapper}>
          <Link action={viewTeamSubview({ id, subview: 'news-injuries', teamName: teamNameSlug })}>
            News
          </Link>
          <span className={classes.verticalLine} />
          <Link action={viewTeamSubview({ id, subview: 'stats', teamName: teamNameSlug })}>
            Stats
          </Link>
          <span className={classes.verticalLine} />
          <Link action={viewTeamSubview({ id, subview: 'roster', teamName: teamNameSlug })}>
            Roster
          </Link>
        </div>
      }
    </div>
  </div>
  )
  }
};

// This creates a div with the Conference/Division name, and the list of the teams
const TeamsByDivision = (conference, conferenceName, divisionName, hasSubLinks) => (
  <div key={`${conferenceName} ${divisionName}`}>
    <div className={classes.teamsDivisionName}>
      {`${conferenceName} ${divisionName}`}
    </div>
    {conference.sort((a, b) => a.city > b.city).map(team =>
      IndividualTeam(team.id, team.logo.large, team.city, team.name, team.slug, hasSubLinks),
    )}
  </div>);

// This arranges the four divisions into two columns, which are then placed into spans
const ArrangeDivisions = (conference, conferenceName, sortedDivisions, hasSubLinks) => {
  const column = [[], []];
  sortedDivisions.forEach((division, i) => {
    column[Math.floor(i / 2)].push(
      TeamsByDivision(conference[division], conferenceName, division, hasSubLinks),
    );
  });
  return column;
};

const TeamGrid = ({ teams: league, hasSubLinks }) => (
  <div className={classes.teamGridWrapper}>
    <div className={classes.afcGroup}>
      {map(league, (conference, conferenceName) =>
        ArrangeDivisions(conference, conferenceName, SORTED_DIVISIONS, hasSubLinks)
          .map((item, i) => item[i].key.includes('AFC') &&
            (<span className={classes.teamsColumn}>{item}</span>),
        ),
      )}
    </div>
    <div className={classes.nfcGroup}>
      {map(league, (conference, conferenceName) =>
        ArrangeDivisions(conference, conferenceName, SORTED_DIVISIONS, hasSubLinks)
          .map((item, i) => item[i].key.includes('NFC') &&
            (<span className={classes.teamsColumn}>{item}</span>),
        ),
      )}
    </div>
  </div>
);

TeamGrid.propTypes = {
  teams: TeamsType.isRequired,
  hasSubLinks: PT.bool,
};

TeamGrid.defaultProps = {
  hasSubLinks: false,
};

export default TeamGrid;




// WEBPACK FOOTER //
// ./src/app/components/Team/TeamGrid.js